import ApplicationLayoutBodyBanner from '@rio-cloud/rio-uikit/ApplicationLayoutBodyBanner';
import { FormattedMessage } from 'react-intl';

const DowntimeBanner = () => (
    <ApplicationLayoutBodyBanner backgroundColor='bg-info' isSticky={false} className='padding-x-20 padding-y-10'>
        <div className='container fluid-large'>
            <FormattedMessage id='intl-msg:rental-web.banner.asset-administration-downtime' />
        </div>
    </ApplicationLayoutBodyBanner>
);

export default DowntimeBanner;
